export default "__VITE_ASSET__b7ca6ded__"